import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsFor() {
  const isFor = ['Para quienes tienen un evento especial y quieren el regalo más impactante del año.', 'Para reposteras que quieren añadir el producto más actual y rentable a su menú.', 'Para amantes de las tendencias que no quieren pagar precios excesivos de reventa.'];
  const isNotFor = ['Para personas que buscan una receta de dieta (esto es lujo real e indulgente).', 'Para quienes no están dispuestos a seguir pasos precisos de temperatura y tiempo.'];
  return <section className="py-24 px-6 bg-dark" data-id="element-170">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-171">
        {/* Who this is for */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="bg-dark-card p-8 md:p-10 rounded-xl border border-emerald/20" data-id="element-172">
          <h3 className="font-serif text-2xl text-cream mb-8 flex items-center gap-3" data-id="element-173">
            <span className="w-10 h-10 rounded-full bg-emerald/10 flex items-center justify-center" data-id="element-174">
              <CheckCircle2 className="text-emerald w-6 h-6" data-id="element-175" />
            </span>
            Esto es para ti si...
          </h3>
          <ul className="space-y-6" data-id="element-176">
            {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-177">
                <CheckCircle2 className="w-5 h-5 text-emerald mt-1 flex-shrink-0" data-id="element-178" />
                <span className="font-sans text-cream-muted leading-relaxed" data-id="element-179">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>

        {/* Who this is NOT for */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} viewport={{
        once: true
      }} className="bg-dark-card p-8 md:p-10 rounded-xl border border-red-900/20" data-id="element-180">
          <h3 className="font-serif text-2xl text-cream mb-8 flex items-center gap-3" data-id="element-181">
            <span className="w-10 h-10 rounded-full bg-red-900/10 flex items-center justify-center" data-id="element-182">
              <XCircle className="text-red-500/80 w-6 h-6" data-id="element-183" />
            </span>
            Esto NO es para ti si...
          </h3>
          <ul className="space-y-6" data-id="element-184">
            {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-185">
                <XCircle className="w-5 h-5 text-red-500/80 mt-1 flex-shrink-0" data-id="element-186" />
                <span className="font-sans text-cream-muted leading-relaxed" data-id="element-187">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}